import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import StepCard from './StepCard';
import ServiceCard from './ServiceCard';
import './Services.css';

const Services: React.FC = () => {
  const { t } = useLanguage();

  // Parse features from translation string (separated by |)
  const parseFeatures = (featureString: string): string[] => {
    return featureString.split('|').map(f => f.trim());
  };

  return (
    <section className="section-container">
      <Container fluid="lg">
       

        {/* Solutions Section */}
        <div className="solutions-section">
          <h3 className="section-subtitle text-center">{t('services.solutions.title')}</h3>
          <div className="solutions-cards-container">
            <div className="solution-card">
              <ServiceCard
                title={t('services.solutions.software.title')}
                features={parseFeatures(t('services.solutions.software.features'))}
              />
            </div>
            <div className="solution-card">
              <ServiceCard
                title={t('services.solutions.iot.title')}
                features={parseFeatures(t('services.solutions.iot.features'))}
              />
            </div>
            <div className="solution-card">
              <ServiceCard
                title={t('services.solutions.ai.title')}
                features={parseFeatures(t('services.solutions.ai.features'))}
              />
            </div>
            <div className="solution-card">
              <ServiceCard
                title={t('services.solutions.web.title')}
                features={parseFeatures(t('services.solutions.web.features'))}
              />
            </div>
            <div className="solution-card">
              <ServiceCard
                title={t('services.solutions.training.title')}
                features={parseFeatures(t('services.solutions.training.features'))}
              />
            </div>
            <div className="solution-card">
              <ServiceCard
                title={t('services.solutions.elearning.title')}
                features={parseFeatures(t('services.solutions.elearning.features'))}
              />
            </div>
          </div>
        </div>

        {/* Original Services Grid */}
        {/* <div className="original-services-section">
          <h3 className="section-subtitle text-center" style={{ marginBottom: '3rem' }}>Más Servicios / More Services</h3>
          <div className="services-grid">
            <div className="service-item top-left">
              <h3>{t('services.consulting.title')}</h3>
              <ul className="service-list">
                <li>
                  <b>{t('services.consulting.project.title')}</b>
                  <br />
                  {t('services.consulting.project.text')}
                </li>
                <li>
                  <b>{t('services.consulting.proposals.title')}</b>
                  <br />
                  {t('services.consulting.proposals.text')}
                </li>
                <li>
                  <b>{t('services.consulting.successfulProjects.title')}</b>
                  <br />
                  {t('services.consulting.successfulProjects.text')}
                </li>
                <li>
                  <b>{t('services.consulting.failedProjects.title')}</b>
                  <br />
                  {t('services.consulting.failedProjects.text')}
                </li>
              </ul>
            </div>
            <div className="service-item top-right">
              <h3>{t('services.aiPlatform.title')}</h3>
              <ul className="service-list">
                <li>
                  <b>{t('services.aiPlatform.smartSearch.title')}</b>
                  <br />
                  {t('services.aiPlatform.smartSearch.text')}
                </li>
                <li>
                  <b>{t('services.aiPlatform.managementDashboards.title')}</b>
                  <br />
                  {t('services.aiPlatform.managementDashboards.text')}
                </li>
                <li>
                  <b>{t('services.aiPlatform.budgetsAndTime.title')}</b>
                  <br />
                  {t('services.aiPlatform.budgetsAndTime.text')}
                </li>
                <li>
                  <b>{t('services.aiPlatform.humanResources.title')}</b>
                  <br />
                  {t('services.aiPlatform.humanResources.text')}
                </li>
              </ul>
            </div>
            <div className="service-item bottom-left">
              <h3>{t('services.development.title')}</h3>
              <ul className="service-list">
                <li>
                  <b>{t('services.development.customProgramming.title')}</b>
                  <br />
                  {t('services.development.customProgramming.text')}
                </li>
                <li>
                  <b>{t('services.development.mobileApps.title')}</b>
                  <br />
                  {t('services.development.mobileApps.text')}
                </li>
                <li>
                  <b>{t('services.development.webPlatforms.title')}</b>
                  <br />
                  {t('services.development.webPlatforms.text')}
                </li>
                <li>
                  <b>{t('services.development.thirdPartySolutions.title')}</b>
                  <br />
                  {t('services.development.thirdPartySolutions.text')}
                </li>
              </ul>
            </div>
            <div className="service-item bottom-right">
              <h3>{t('services.training.title')}</h3>
              <ul className="service-list">
                <li>
                  <b>{t('services.training.newTechnologies.title')}</b>
                  <br />
                  {t('services.training.newTechnologies.text')}
                </li>
                <li>
                  <b>{t('services.training.informationTechnologies.title')}</b>
                  <br />
                  {t('services.training.informationTechnologies.text')}
                </li>
                <li>
                  <b>{t('services.training.newProcesses.title')}</b>
                  <br />
                  {t('services.training.newProcesses.text')}
                </li>
                <li>
                  <b>{t('services.training.createdPlatforms.title')}</b>
                  <br />
                  {t('services.training.createdPlatforms.text')}
                </li>
              </ul>
            </div>
          </div>
        </div> */}
      </Container>
    </section>
  );
};

export default Services;
